import PropTypes from 'prop-types';
import React from 'react';
import FormMessage from '../../FormMessage';
import BetList from '../BetList';
import LoadNextSlip from '../LoadNextSlip';
import ToBePaidOutEmpty from './ToBePaidOutEmpty';

const ToBePaidOut = ({ hasBets, bets, showLoadNextSlip }) => ((hasBets) ? (
  <div className="to-be-paid-out">
    <h2 className="to-be-paid-out__header">
      Collect your winnings
    </h2>
    <p className="to-be-paid-out__note">
      Returns from online funded bets are automatically deposited into your account.
    </p>
    <FormMessage className="to-be-paid-out__message" />
    <BetList bets={bets} />
    {showLoadNextSlip && <LoadNextSlip>Load more</LoadNextSlip>}
  </div>
) : (<ToBePaidOutEmpty />));

ToBePaidOut.propTypes = {
  hasBets: PropTypes.bool.isRequired,
  bets: PropTypes.object.isRequired,
  showLoadNextSlip: PropTypes.bool
};

export default ToBePaidOut;
